const getCategoryLabel = (category, i18n) => {
    return { en: category === null || category === void 0 ? void 0 : category.typeLabelEN, pl: category === null || category === void 0 ? void 0 : category.typeLabelPL }[i18n.language];
};
export default getCategoryLabel;
